const _le_t = window.ShopifyConstant.getCookie(window.ShopifyConstant.multipassToken)
if (_le_t) {
  window.ShopifyConstant.deleteCookie(window.ShopifyConstant.multipassToken)
}

// 同时清除登录来源标识
const _le_source = window.ShopifyConstant.getCookie(window.ShopifyConstant.loginSourceKey)
if (_le_source) {
  window.ShopifyConstant.deleteCookie(window.ShopifyConstant.loginSourceKey)
}